module.exports = __webpack_public_path__ + "img/bars-progress-solid.21d07778.svg";